Alpine.data('mediaList', () => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	let dropdowns;

	return {
		show: false,

		inputs: {
			'press-type': urlSearchParams.get('press-type') || '',
			issues: urlSearchParams.get('issues') || '',
		},

		init() {
			dropdowns = this.$root.querySelectorAll('select');

			this.listenToBrowserResize();

			setTimeout(() => {
				this.setDropdownWidths();
			}, 100);
		},

		listenToBrowserResize() {
			const mql = window.matchMedia('screen and (min-width: 992px)');

			const handleChange = () => {
				this.setDropdownWidths();
			};

			if (typeof mql.addEventListener === 'function') {
				mql.addEventListener('change', () => {
					handleChange();
				});
			} else if (typeof mql.addListener === 'function') {
				mql.addListener(() => {
					handleChange();
				});
			}

			handleChange();
		},

		setDropdownWidths() {
			const arrowSize = 25;

			dropdowns.length &&
				[...dropdowns].forEach((dropdown) => {
					const style = window.getComputedStyle(dropdown);
					const { fontWeight, fontSize, fontFamily } = style;

					// Create an invisible span element with the correct font styles of the dropdown
					// to calculate the width of the text.
					const dropdownText = dropdown.selectedOptions[0].textContent;
					const span = document.createElement('span');
					span.innerText = dropdownText;
					span.style.fontFamily = fontFamily;
					span.style.fontSize = fontSize;
					span.style.fontWeight = fontWeight;
					span.style.visibility = 'hidden';

					// Inject the element into the DOM temporarily, grab the width of the text and clean up.
					this.$refs.temp.appendChild(span);
					const textWidth = span.getBoundingClientRect().width;
					this.$refs.temp.removeChild(span);

					dropdown.style.width = `${textWidth + arrowSize}px`;
				});

			// Show the filters after we perform a resize - this hides a jitter that happens while the
			// dropdowns get their sizes calculated.
			if (!this.show) {
				this.show = true;
			}
		},

		updateFilter() {
			this.setDropdownWidths();

			this.$refs.filterForm.submit();
		},
	};
});
